import { useGetProductCatalogMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'

export const DescriptionChapter = ({ productDescription }) => {
    const createMarkup = () => {
        return { __html: productDescription }
    }

    return (
        <div className={'DescriptionChapter'}>
            <div dangerouslySetInnerHTML={createMarkup()} />
        </div>
    )
}
